import { ICita } from '../trjireh-model';

export class Cita implements ICita {
    public IdCita: number;
    public Fecha: Date;
    public Contacto: number;
    public Descripcion: string;
    public Comentario: string;
    public Aseguradora: number;
    public idSucursal: number;
    public idStatusCita: number;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/cita.ts